export const MESSAGE_COMMON_ERROR = '문제가 발생했습니다. 다시 시도해 주세요.';
export const MESSAGE_EDIT_SUCCESS = '변경 사항을 저장했습니다.';
export const MESSAGE_CREATE_SUCCESS = '성공적으로 추가되었습니다.';



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/shared/message.ts